import { RightOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Divider,
  Row,
  Skeleton,
  Space,
  Typography
} from 'antd';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { CONFIG, TIPOS_PRODUCTOS } from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import { getIcon, hexToRgb } from '../../utils';

const { Title, Text } = Typography;

const CustomTitle = ({ children }) => <Title>{children}</Title>;
const CustomSubTitle = ({ children }) => (
  <Title level={3} style={{ fontWeight: 500, lineHeight: '22px' }}>
    {children}
  </Title>
);
const GroupTitle = ({ children }) => (
  <Text style={{ fontWeight: 590, lineHeight: '30px', fontSize: 20 }}>
    {children}
  </Text>
);

const ProductoItem = ({ titulo, lista, onClick }) => {
  return (
    <div style={{ textAlign: 'left', margin: 'auto' }}>
      <Divider orientation="left" orientationMargin={0}>
        <GroupTitle>{titulo}</GroupTitle>
      </Divider>
      <Space direction="vertical" style={{ width: '100%' }}>
        {lista.map((item, index) => (
          <Button
            size="large"
            key={index}
            style={{ textAlign: 'left', display: 'flex', alignItems: 'center' }}
            icon={getIcon(item.codigo)}
            onClick={() => onClick(item)}
            block
          >
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                color: 'inherit'
              }}
            >
              <Text ellipsis style={{ color: 'inherit' }}>
                {item.descripcion}
              </Text>
              <span style={{ float: 'right' }}>
                <RightOutlined />
              </span>
            </span>
          </Button>
        ))}
      </Space>
    </div>
  );
};

const EmptyItem = () => (
  <>
    <Divider orientation="left" orientationMargin={0}>
      <GroupTitle>
        <Skeleton.Button
          active
          size="small"
          style={{ width: 150, height: 16, verticalAlign: 'sub' }}
        />
      </GroupTitle>
    </Divider>
    <Space
      direction="vertical"
      style={{
        width: '100%'
      }}
      size={16}
    >
      <Skeleton.Button active block />
      <Skeleton.Button active block />
    </Space>
  </>
);

const LandingCotizacion = () => {
  const history = useHistory();
  const { productos, updateProducto } = useContext(EmpresaContext);
  const listaProductos = productos || [];
  const personales = listaProductos.filter((item) =>
    [2, 3].includes(item.codigo)
  );
  const patrimoniales = listaProductos.filter((item) =>
    [4, 5].includes(item.codigo)
  );
  const vehiculo = listaProductos.filter((item) => [1].includes(item.codigo));
  const viajes = listaProductos.filter((item) => [8].includes(item.codigo));

  const color = `rgb(${hexToRgb(CONFIG.COLOR_PRIMARY)}, 0.08)`;
  const onClick = (producto) => {
    updateProducto(producto.codigo);
    const { link } = TIPOS_PRODUCTOS.find(
      ({ codigo }) => codigo === producto.codigo
    );
    history.push(`${link}`);
  };
  return (
    <ResponsiveContainer>
      <LogosEmpresaAseguradora soloEmpresa> </LogosEmpresaAseguradora>
      <Card bordered={false} style={{ paddingBottom: 64 }}>
        <CustomTitle>Cotizar</CustomTitle>
        <CustomSubTitle>¿Qué te gustaría asegurar?</CustomSubTitle>
        <br />
        <Card
          bordered
          style={{ maxWidth: 650, margin: 'auto', background: color }}
        >
          <div style={{ textAlign: 'center' }}>
            {listaProductos.length > 0 ? (
              <Row gutter={[64, { xs: 8, md: 32 }]}>
                {patrimoniales.length > 0 && (
                  <Col md={12} xs={24}>
                    <ProductoItem
                      titulo="Tus bienes"
                      lista={patrimoniales}
                      onClick={onClick}
                    />
                  </Col>
                )}
                {vehiculo.length > 0 && (
                  <Col md={12} xs={24}>
                    <ProductoItem
                      titulo="Tus vehículos"
                      lista={vehiculo}
                      onClick={onClick}
                    />
                  </Col>
                )}
                {personales.length > 0 && (
                  <Col md={12} xs={24}>
                    <ProductoItem
                      titulo="Personas"
                      lista={personales}
                      onClick={onClick}
                    />
                  </Col>
                )}
                {viajes.length > 0 && (
                  <Col md={12} xs={24}>
                    <ProductoItem
                      titulo="Otros"
                      lista={viajes}
                      onClick={onClick}
                    />
                  </Col>
                )}
              </Row>
            ) : (
              <Row gutter={[64, { xs: 8, md: 32 }]}>
                <Col md={12} xs={24}>
                  <EmptyItem />
                </Col>
                <Col md={12} xs={24}>
                  <EmptyItem />
                </Col>
                <Col md={12} xs={24}>
                  <EmptyItem />
                </Col>
                <Col md={12} xs={24}>
                  <EmptyItem />
                </Col>
              </Row>
            )}
          </div>
        </Card>
      </Card>
    </ResponsiveContainer>
  );
};

export default LandingCotizacion;
